import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataInput} from 'shared/dtos/data-input'; // NOSONAR
import {Mitarbeiter} from 'shared/dtos/mitarbeiter'; // NOSONAR
import {TEMOST_CONST} from 'shared/EnumsConstants/global-enum';

export class FileUploadRepository {
  private readonly exportExcelAnalyseDataUrl =
    'api/Download/exportmitarbeiterdatafile';
  private readonly exportExcelKontrollmodusAnalyseDataUrl =
    'api/Download/exportmitarbeiterdatafile/kontrollmodus';
  private readonly exportcomplianceriskComparepaaredatafile =
    'api/Download/exportcomplianceriskComparepaaredatafile';
  private readonly ComplianceRiskVergleichspaareForKontrollmodus =
    'api/Download/exportcomplianceriskComparepaaredatafile/kontrollmodus';
  private readonly url = 'api/fileUpload';
  private readonly defaultUrl = 'api/fileUpload/download';
  constructor(private readonly httpClient: HttpClient) {}

  public getDataInputFromImportFile(
    formData: FormData,
    crtLanguage: string,
    isForModule2?: boolean
  ): Observable<HttpEvent<DataInput>> {
    let url = `${this.url}/uploaddata?language=${crtLanguage}`;
    if (isForModule2) {
      url = `${this.url}/uploaddata/m2?language=${crtLanguage}`;
    }
    const uploadReq = new HttpRequest('POST', url, formData, {
      reportProgress: true
    });
    return this.httpClient.request<DataInput>(uploadReq);
  }

  public getMitarbeiters(
    formData: FormData
  ): Observable<HttpEvent<Mitarbeiter[]>> {
    const uploadReq = new HttpRequest(
      'POST',
      `${this.url}/uploaddata`,
      formData,
      {reportProgress: true}
    );
    return this.httpClient.request<Mitarbeiter[]>(uploadReq);
  }
  public getExportExcelAnalyseData<T>(
    dataInput: T,
    crtLanguage: string,
    sender: string,
    isKontrollmodus: boolean
  ): Observable<HttpEvent<Blob>> {
    const url = this.getUrl(sender, crtLanguage, isKontrollmodus);
    return this.httpClient.request(
      new HttpRequest('POST', url, dataInput, {
        reportProgress: true,
        responseType: 'blob'
      })
    );
  }

  public download(
    crtLanguage: string,
    url?: string
  ): Observable<HttpEvent<Blob>> {
    const theUrl = url ? url : this.defaultUrl;
    return this.httpClient.request(
      new HttpRequest('GET', `${theUrl}?crtLanguage=${crtLanguage}`, null, {
        reportProgress: true,
        responseType: 'blob'
      })
    );
  }

  public downloadFromAssets(url: string): Observable<HttpEvent<Blob>> {
    return this.httpClient.request(
      new HttpRequest('GET', url, null, {
        reportProgress: true,
        responseType: 'blob'
      })
    );
  }

  private getUrl(
    sender: string,
    crtLanguage: string,
    isKontrollmodus: boolean
  ) {
    const queryString = `crtLanguage=${crtLanguage}`;
    const router = isKontrollmodus
      ? this.exportExcelKontrollmodusAnalyseDataUrl
      : this.exportExcelAnalyseDataUrl;

    switch (sender) {
      case TEMOST_CONST.Sender.Module1:
        return `${router}/m1?${queryString}`;
      case TEMOST_CONST.Sender.Module2:
        return `${router}/m2?${queryString}`;
      case TEMOST_CONST.Sender.ComplianceRiskVergleichspaare:
        return `${this.exportcomplianceriskComparepaaredatafile}/?crtLanguage=${crtLanguage}`;
      case TEMOST_CONST.Sender.ComplianceRiskVergleichspaareForKontrollmodus:
        return `${this.ComplianceRiskVergleichspaareForKontrollmodus}/?crtLanguage=${crtLanguage}`;
      default:
        console.error('ERROR', sender);
        throw new Error('Unexpected getUrl');
    }
  }
}
